import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PFXLogoAttributes, PFXLogoShape } from "../../../../models/Interfaces";
import { selectComponentDimensions } from "../../../../redux/slices/landingSlice";

interface ILogo {
  logo: PFXLogoAttributes;
  url: string;
}

const Logo = ({ logo, url }: ILogo) => {
  const { height } = useSelector(selectComponentDimensions);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        zIndex: 2,
      },
      img: {
        maxHeight: height / 4,
        height: logo?.shape! === PFXLogoShape.CIRCLE ? height / 4 : "",
        width: logo?.shape! === PFXLogoShape.CIRCLE ? height / 4 : "auto",
        objectFit: "cover",
        borderRadius: logo?.shape === PFXLogoShape.CIRCLE ? "30pc" : 9,
        boxShadow: logo?.shape === PFXLogoShape.CIRCLE ? "1pt 1pt 7px -3px #00000070" : "none",
      },
    })
  );

  const classes = useStyles();

  return logo?.activate ? (
    <Grid item container justifyContent={(logo.alignment as any) ?? "center"} className={classes.root}>
      <Grid item>
        <img src={url} alt={"company logo"} className={classes.img} />
      </Grid>
    </Grid>
  ) : null;
};
export default Logo;
